import { MixedItem } from 'store/railsBuilder/reducer.types';

import isBtvProgrammeItem from 'services/data-manager/parsing/utils/isBtvProgrammeItem';
import isVodEditorialItem from 'services/data-manager/parsing/utils/isVodEditorialItem';
import { DeeplinkRecommendation } from 'services/data-manager/types';

import parseRBBtvProgrammeToMixedItem from './parseRBBtvProgrammeToMixedItem';
import parseRBVodEditorialToMixedItem from './parseRBVodEditorialToMixedItem';

function parseRBDeepLinkRecommendationToMixedItem(
    deepLinkItem: DeeplinkRecommendation,
): MixedItem | undefined {
    if (isVodEditorialItem(deepLinkItem.editorial)) {
        return parseRBVodEditorialToMixedItem(deepLinkItem.editorial);
    }

    if (isBtvProgrammeItem(deepLinkItem.editorial)) {
        return parseRBBtvProgrammeToMixedItem(deepLinkItem.editorial);
    }

    return undefined;
}

export default parseRBDeepLinkRecommendationToMixedItem;
